module.exports = "../../static/fonts/Lato-Bold.44dfe8c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Bold.ttf
// module id = 913
// module chunks = 2